export const castString = (value: any): string => {
	if (value) {
		return value.toString();
	}
	return "";
};
